import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import * as Styled from './LoginPage.styled';
import { ExternalLoginPanel } from './ExternalLoginPanel';

interface AzureLoginPanelProps {
  readonly azureClientId: string;
  readonly azureRedirectUri: string;
  readonly azureDescription: string;
}

const NONCE_LENGTH = 10;

const generateNonce = (): string => {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let nonce = '';
  for (let i = 0; i < NONCE_LENGTH; i++) {
    nonce += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return nonce;
};

export const AzureLoginPanel = ({ azureClientId, azureRedirectUri, azureDescription }: AzureLoginPanelProps) => {
  const intl = useIntl();

  const handleAzureLogin = useCallback(() => {
    const authUrl =
      'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?' +
      'client_id=' +
      azureClientId +
      '&response_type=code' +
      '&scope=User.Read%20Mail.Read' +
      '&response_mode=form_post' +
      '&nonce=' +
      generateNonce() +
      '&redirect_uri=' +
      encodeURIComponent(azureRedirectUri);

    window.location.href = authUrl;
  }, [azureClientId, azureRedirectUri]);

  return (
    <ExternalLoginPanel panelId="azureLogin" description={azureDescription}>
      <Styled.PanelButton id="azureLoginButton" priority="primary" onClick={handleAzureLogin}>
        {intl.formatMessage({ id: 'signIn', defaultMessage: 'Sign in' })}
      </Styled.PanelButton>
    </ExternalLoginPanel>
  );
};
